import React from "react";
import clsx from "clsx";

interface OverviewItemProps {
  date: string;
  time: string;
  tags: string[];
  title: string;
  speakerName: string;
  speakerPhoto: string;
  speakerPosition: string;
  isTopRow?: boolean;
}

const OverviewItem = ({
  date,
  time,
  tags,
  title,
  speakerName,
  speakerPhoto,
  speakerPosition,
  isTopRow = true,
}: OverviewItemProps): JSX.Element => {
  return (
    <div
      className={clsx(
        "flex flex-col p-5 outline outline-solid outline-[1px] outline-light-gray rounded-xl gap-6",
        "md:p-10",
        isTopRow ? "xl:h-[340px]" : "xl:h-[300px]",
        "2xl:gap-[30px] 2xl:h-[268px]",
        "3xl:h-[272px] 3xl:gap-8",
        "4xl:h-[279px]"
      )}
    >
      <div className="flex flex-col gap-[14px] md:flex-row md:justify-between lg:justify-start lg:flex-col 2xl:flex-row 2xl:justify-between">
        <div className="flex items-center max-h-[30px] 4xl:max-h-auto">
          <span className="text-base md:text-2xl font-bold">{date}</span>
          <span className="px-[10px] font-bold text-2xl">|</span>
          <span className="text-lg md:text-2xl">{time} </span>
          <span className="text-sm md:text-base self-start pl-1 font-light">
            МСК
          </span>
        </div>
        <div className="flex items-center gap-[10px] 2xl:gap-[14px] 3xl:gap-[14px] flex-wrap">
          {tags.map((tag, index) => (
            <span
              key={index}
              className="text-16 h-[33px] leading-[130%] outline outline-solid outline-[1px] outline-red-500 rounded-full px-[14px] py-[6px] md:text-base md:leading-[125%]"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <p className="text-18 !leading-[125%] font-bold md:text-20 lg:text-18 xl:text-20">
        {title}
      </p>

      <div
        className={clsx(
          "flex gap-[10px] pb-[2px] md:pb-[7px] lg:pb-0 xl:pb-[7px] mt-auto",
          { "xl:pb-0": isTopRow }
        )}
      >
        <img
          src={speakerPhoto}
          alt={speakerName}
          className="rounded-full w-[35px] h-[35px] md:w-[45px] md:h-[45px]"
        />
        <div className="flex flex-col gap-[px] gap-[2px] md:gap-1">
          <p className="font-extrabold text-sm !leading-[130%]">
            {speakerName}
          </p>
          <p className="text-[11px] !leading-[135%] lg:w-[250px] xl:w-auto">
            {speakerPosition}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OverviewItem;
